// libs
import React from 'react';

import { Plus } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Button, Typography } from '@lyearn/ui';

// styles
import { buttonStyles } from './styles';

function renderLabel(label: string | React.ReactNode, isSelected: boolean) {
  return (
    <Typography
      as="span"
      className="flex items-center"
      color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
      variant={isSelected ? 'label-02' : 'body-short-02'}>
      {label}
    </Typography>
  );
}

const AddMoreButton = React.forwardRef(
  (
    {
      className,
      children,
      isSelected = false,
      isOpen,
      onClick,
      endIcon,
      startIcon,
    }: {
      className?: string;
      children: string | React.ReactNode;
      isSelected?: boolean;
      isOpen: boolean;
      onClick?: () => void;
      endIcon?: React.ReactNode;
      startIcon?: React.ReactNode;
    },
    ref: React.Ref<HTMLButtonElement> | undefined,
  ) => {
    const inFocus = isSelected || isOpen;

    return (
      <Button
        ref={ref}
        appearance="secondary"
        className={cn(
          'flex-shrink-0 ps-8 pe-12',
          buttonStyles,
          {
            open: isOpen,
            'border-text-primary': isSelected,
            selected: inFocus,
          },
          className,
        )}
        endIcon={endIcon}
        size="small"
        startIcon={
          startIcon ?? (
            <Plus
              className="arrow-icon"
              fillColorToken={inFocus ? 'icon-primary' : 'icon-secondary'}
            />
          )
        }
        variant="outlined"
        onClick={onClick}>
        {renderLabel(children, inFocus)}
      </Button>
    );
  },
);

export default AddMoreButton;
